import React, { ComponentType } from 'react';
import FeatureFlags, {
  FeatureFlagKeys
} from '../../frontend-common-libs/src/components/feature_flags';

export default function withCanOpenFile(WrappedComponent: ComponentType<any>) {
  return function (props: Object) {
    const overrideCanOpen = FeatureFlags().get(FeatureFlagKeys.IMAGE_LAB_TOUCH_METADATA);
    const mergedProps = { ...props, overrideCanOpen };
    return <WrappedComponent {...mergedProps} />;
  };
}
